import { useState } from 'react';

export const useImageLoader = (src) => {
  const [imageFound, setImageFound] = useState(false);
  const handleImageFound = () => setImageFound(true);

  const image = new Image();

  image.onload = handleImageFound;

  image.src = src;

  return imageFound;
};
